const DiscoverFilters = ({
  search_text,
  set_search_text,
  selected_tag_filter,
  set_selected_tag_filter,
  unique_tag_options,
  filtered_count,
  total_count,
  tab_loading,
  filters_stale,
  on_apply_search,
}) => {
  return (
    <div className="mt-0 space-y-3 rounded-lg border border-gray-200 bg-white p-4">
      <div className="text-sm font-semibold text-gray-900">Search and filter (server)</div>

      {filters_stale && (
        <div className="rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-xs font-medium text-amber-900">
          These fields do not match the results below yet. Press <span className="font-semibold">Apply</span> or hit{" "}
          <span className="font-semibold">Enter</span> in the search box to run the search.
        </div>
      )}

      <input
        type="text"
        value={search_text}
        onChange={(e) => set_search_text(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault()
            on_apply_search()
          }
        }}
        className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm text-gray-900 placeholder:text-gray-400"
        placeholder="Search keyword, title, description, tag, id, ticker, slug, text... (Enter to apply)"
      />

      <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
        <select
          value={selected_tag_filter}
          onChange={(e) => set_selected_tag_filter(e.target.value)}
          className="rounded-md border border-gray-300 px-3 py-2 text-sm text-gray-900"
        >
          <option value="all">All tags</option>
          {unique_tag_options.map((tag) => (
            <option key={tag} value={tag}>{tag}</option>
          ))}
        </select>

        <button
          type="button"
          className="rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 disabled:cursor-not-allowed disabled:opacity-60"
          onClick={() => on_apply_search()}
          disabled={tab_loading}
        >
          Apply search & filter
        </button>

        <div className="flex items-center justify-center rounded-md border border-gray-200 bg-gray-50 px-3 py-2 text-xs font-semibold text-gray-600">
          {tab_loading ? "Loading..." : `Showing ${filtered_count} of ${total_count}`}
        </div>
      </div>
    </div>
  )
}

export default DiscoverFilters
